import React from "react";
//ESTILOS
import "./Footer.css";
//PRIMEREACT

function Footer() {
  return (
    <>
      <footer className="grid-nogutter footer">
        <div className="col-12 p-3 md:p-5 md:mt-5">
          <p>
            Brilla opera como medio de financiación no bancario. Ver condiciones
            y restricciones en la página web www.brilla.com.co. Brilla
            únicamente presta servicios de financiación y no actúa en calidad de
            productor, proveedor y/o distribuidor de los productos que los
            clientes adquieren a través del servicio de financiación de Brilla,
            quien actúa con estas calidades es el aliado ante el cual el cliente
            haga la compra. La disponibilidad y garantías de los productos y
            servicios ofertados son ajenos a la operación de Brilla y depende de
            la decisión y funcionamiento autónomo del aliado. La financiación
            dispone de un número máximo de cuotas respecto de las cuales el
            cliente puede elegir cualquiera que se ajuste a sus necesidades de
            financiación por debajo del máximo establecido. La tasa de
            financiación será la máxima autorizada por la Superintendencia
            Financiera de Colombia en el momento de la adquisición del servicio,
            esta, así como el número de cuotas ofertadas para el momento en que
            se adquiere la financiación (que dependen del perfil crediticio del
            cliente y el producto a adquirir) están disponibles permanentemente
            para consulta en los establecimientos de comercio de los aliados y
            en la página web www.brilla.com.co. Aplica en Bolívar. Tenemos 30
            cupos disponibles. Participa del 7 al 20 de mayo por compras iguales
            o superiores a $1’700.000 en cualquiera línea de nuestros aliados .
            El valor debe ser alcanzado en una sola compra y los ganadores serán
            los que primero cumplan con la compra mínima informada y se
            inscriban en la página de inscripción. La página de inscripción al
            evento se cerrará el 20 de mayo o cuando se completen los 30 cupos
            disponibles.
          </p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
